export const GET_SHARED_TEAM_ROOMS = 'GET_SHARED_TEAM_ROOMS';
export const GET_SHARED_TEAM_ROOMS_SUCCESS = 'GET_SHARED_TEAM_ROOMS_SUCCESS';
export const GET_SHARED_TEAM_ROOMS_FAILURE = 'GET_SHARED_TEAM_ROOMS_FAILURE';
export const DELETE_SHARED_TEAM_ROOM = 'DELETE_SHARED_TEAM_ROOM';
export const DELETE_SHARED_TEAM_ROOM_SUCCESS =
	'DELETE_SHARED_TEAM_ROOM_SUCCESS';
export const LOAD_MORE_SHARED_TEAM_ROOMS = 'LOAD_MORE_SHARED_TEAM_ROOMS';
export const LOAD_MORE_SHARED_TEAM_ROOMS_SUCCESS =
	'LOAD_MORE_SHARED_TEAM_ROOMS_SUCCESS';
